import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { APITeam } from '../../../../../../../../typings/Team.interface';
import { ClickableArea } from '../../../../common/base/Button';
import { StyledCardSection } from '../../../../common/base/Card';
import Icon from '../../../../common/base/Icon';
import Text from '../../../../common/base/Text';
import Tooltip from '../../../../common/base/Tooltip';
import { StyledUtilsProps } from '../../../../common/helpers/StyledUtils';
import { useToasts } from '../../../../common/Toast';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { UserContext } from '../../../../contexts/UserContext';
import useSearchQuery from '../../../../hooks/useSearchQuery';
import { DashboardContext } from '../../DashboardContext';
import NewOrganizationModal from './NewOrganization';
import NewTeamModal from './NewTeam';
import TeamSelectionList from './TeamSelectionList';
const TeamSelection = t0 => {
  const $ = _c(37);
  const {
    h
  } = t0;
  const {
    setAPITeamId
  } = useContext(GlobalContext);
  const {
    user
  } = useContext(UserContext);
  const {
    team,
    organization,
    organizations,
    teams,
    mutateTeams,
    mutateOrganizations,
    organization_role
  } = useContext(DashboardContext);
  const history = useHistory();
  const location = useLocation();
  const {
    addToast
  } = useToasts();
  const {
    query,
    updateSearchQuery
  } = useSearchQuery();
  let t1;
  if ($[0] !== location.pathname) {
    const sections = location.pathname.split("/");
    const first_id_index = sections.findIndex(_temp);
    t1 = first_id_index > 0 ? sections.slice(0, first_id_index).join("/") : location.pathname;
    $[0] = location.pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const root_path = t1;
  let t2;
  if ($[2] !== addToast || $[3] !== history || $[4] !== location || $[5] !== mutateOrganizations || $[6] !== mutateTeams || $[7] !== root_path || $[8] !== setAPITeamId) {
    t2 = (team_0, previous_team, to) => {
      setAPITeamId(team_0.id);
      const use_root_path = previous_team && previous_team.type === team_0.type;
      const redirect_location = {
        ...location,
        pathname: to || "/",
        search: ""
      };
      if (use_root_path && location.pathname !== "/projects") {
        redirect_location.pathname = root_path;
      }
      history.push(redirect_location);
      addToast("success", `You've switched to project ${team_0.name}`);
      setTimeout(() => {
        mutateTeams();
        mutateOrganizations();
      }, 0);
    };
    $[2] = addToast;
    $[3] = history;
    $[4] = location;
    $[5] = mutateOrganizations;
    $[6] = mutateTeams;
    $[7] = root_path;
    $[8] = setAPITeamId;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const handleTeamChange = t2;
  let t3;
  if ($[10] !== handleTeamChange) {
    t3 = team_1 => {
      handleTeamChange(team_1, undefined, "/get-started");
    };
    $[10] = handleTeamChange;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const handleTeamCreate = t3;
  let t4;
  if ($[12] !== handleTeamCreate || $[13] !== query.new || $[14] !== updateSearchQuery) {
    t4 = query.new === "organization" && <NewOrganizationModal onClose={() => updateSearchQuery({
      new: undefined
    })} onSuccess={handleTeamCreate} />;
    $[12] = handleTeamCreate;
    $[13] = query.new;
    $[14] = updateSearchQuery;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== handleTeamCreate || $[17] !== query.new || $[18] !== query.organization_id || $[19] !== updateSearchQuery) {
    t5 = query.new === "project" && query.organization_id && <NewTeamModal organization_id={query.organization_id} onClose={() => updateSearchQuery({
      new: undefined,
      organization_id: undefined
    })} onSuccess={handleTeamCreate} />;
    $[16] = handleTeamCreate;
    $[17] = query.new;
    $[18] = query.organization_id;
    $[19] = updateSearchQuery;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  const t6 = team?.id;
  const t7 = organization?.id;
  let t8;
  if ($[21] !== organization_role || $[22] !== updateSearchQuery || $[23] !== user?.sso_idp_id) {
    t8 = t9 => {
      const {
        focused_organization_id
      } = t9;
      return {
        organizations: !user?.sso_idp_id ? <StyledCardSection m={{
          t: "auto"
        }} p={1}><ClickableArea onClick={() => updateSearchQuery({
            new: "organization"
          })} p={{
            y: 1.5,
            x: 2
          }} rounded={true} flex={{
            align: "center"
          }}><Icon icon="add_circle" muted={true} left={true} pointer={true} /><Text>New organization</Text></ClickableArea></StyledCardSection> : null,
        teams: focused_organization_id ? <StyledCardSection m={{
          t: "auto"
        }} flex={true} p={1}><Tooltip fill={true} tooltip="You don't have permission to create a project, contact your admin" disabled={organization_role !== "viewer"}><ClickableArea block={true} onClick={() => updateSearchQuery({
              new: "project",
              organization_id: focused_organization_id
            })} disabled={organization_role === "viewer"} p={{
              y: 1.5,
              x: 2
            }} rounded={true} flex={{
              align: "center"
            }}><Icon muted={true} icon="add_circle" left={true} pointer={true} /><Text>New project</Text></ClickableArea></Tooltip></StyledCardSection> : null
      };
    };
    $[21] = organization_role;
    $[22] = updateSearchQuery;
    $[23] = user?.sso_idp_id;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== h || $[26] !== handleTeamChange || $[27] !== organizations || $[28] !== t6 || $[29] !== t7 || $[30] !== t8 || $[31] !== teams) {
    t9 = <TeamSelectionList h={h} organizations={organizations} teams={teams} selected_team_id={t6} default_organization_id={t7} onTeamSelect={handleTeamChange} footer={t8} />;
    $[25] = h;
    $[26] = handleTeamChange;
    $[27] = organizations;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
    $[31] = teams;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== t4 || $[34] !== t5 || $[35] !== t9) {
    t10 = <>{t4}{t5}{t9}</>;
    $[33] = t4;
    $[34] = t5;
    $[35] = t9;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  return t10;
};
export default TeamSelection;
function _temp(section) {
  return section.includes("_");
}